import { getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Currency } from './model/currency';

@Pipe({
  name: 'currencyCode'
})
export class CurrencyCodePipe implements PipeTransform {
  transform(value: Currency, format: 'wide' | 'narrow' = 'wide'): string {
    return getCurrencySymbol(value, format, 'en-US');
  }
}
